if (!customElements.get('stories-highlight')) {
	class StoriesHighlight extends HTMLElement {
		constructor() {
			super();
			this.targetIndex = this.getAttribute('data-story-target-index');
			this.storiesGallery = document.querySelector('stories-gallery');
			this.targetElement = null;
			this.targetId = this.getAttribute('data-story-target-id');
			if(this.targetId) this.targetElement = document.querySelector(`script.product-stories[data-story-collection="${this.targetId}"]`);
			if(!this.targetElement) {
				return;
			}
			if(this.storiesGallery) this.addEventListener('click', this.onTargetElementClicked.bind(this));
		}
		onTargetElementClicked() {
			!this.classList.contains('has-seen') ? this.classList.add('has-seen') : null;
			const canBuildGalleryItems = this.storiesGallery.buildGalleryItems(this.targetElement);
			if(!canBuildGalleryItems) return;
			this.storiesGallery.initProgressBars();
			this.storiesGallery.goToSlide(0, true);
			this.storiesGallery.openGallery();
			this.storiesGallery.startActions();
		}
	}
	customElements.define('stories-highlight', StoriesHighlight);
}
export { StoriesHighlight };